export const log="login";
export const logout="logout"